export class Logger {
    static error(message, error) {
        console.error(message, error);
        // Add your logging service integration here
    }

    static info(message, data) {
        console.log(message, data);
    }

    static warn(message, data) {
        console.warn(message, data);
    }
}